﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:MarkCompleteController
 * @description
 * # MarkCompleteController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('MarkCompleteController', function ($uibModalInstance, $scope, data) {
      $scope.data = data;

      $scope.dismiss = function () {
          $uibModalInstance.dismiss();
      };

      $scope.mark = function () {
          $uibModalInstance.close(data.duration);
      };
  });